export default __webpack_public_path__ + "static/media/M_logo_image.0868720f.png";